import { render, staticRenderFns } from "./DxBinsContentGridPlanning.vue?vue&type=template&id=33b44fc2&"
import script from "./DxBinsContentGridPlanning.vue?vue&type=script&lang=js&"
export * from "./DxBinsContentGridPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports